function initializeImageBannerClickHandlers() {
  const banners = document.querySelectorAll('.image-banner[data-image-banner-click-url]');

  banners.forEach(function (banner) {
    try {
      if (banner.dataset.imageBannerClickInit === 'true') {
        return;
      }

      const targetUrl = banner.dataset.imageBannerClickUrl;
      if (!targetUrl) {
        return;
      }

      const imageArea = banner.querySelector('.image-banner__image');
      if (!imageArea) {
        return;
      }

      imageArea.style.cursor = 'pointer';
      imageArea.addEventListener('click', function (event) {
        const interactiveTarget = event.target.closest('a, button, input, select, textarea, [role="button"], [role="link"]');
        if (interactiveTarget) {
          return;
        }
        window.location.href = targetUrl;
      });

      banner.dataset.imageBannerClickInit = 'true';
    } catch (error) {
      console.error('Error processing image banner click handler:', error);
    }
  });
}

document.addEventListener('DOMContentLoaded', initializeImageBannerClickHandlers);

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', initializeImageBannerClickHandlers);
}
